<!-- 废弃 -->
<template>
	<div>
		<myheader :backFlag="true" headTitle="认证方式"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text12 textcolor999 font_weight_bold">请选择个人实名认证方式</div>
					<div class="text14 textcolor666 margin_top_10">认证方式</div>
					<div class="all_tips_input display_flex">
						<div class="width_flex all_height_line14 text14 textcolor333 font_weight_900">
							{{authStyle=='0'?'手机认证+人脸识别':'银行卡认证+人脸识别'}}
						</div>
						<div class="selectstyle all_height_line14 text14 textcolor333 font_weight_900 display_flex"
							@click="showBottom = true">更换方式</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor999 font_weight_bold">
						{{authStyle=='0'?'请填写手机号码以及手机验证码':'请填写银行卡以及预留手机号码与手机验证码'}}
					</div>
					<div v-show="authStyle!='0'" class="all_tips_red text14 textcolor666 margin_top_10">银行卡号</div>
					<div v-show="authStyle!='0'" class="all_tips_input" :class="{ isfocus: backnuFocus }">
						<input class="my_input all_height_line14 text14 textcolor333" v-model="backNumber" @focus="getFocus(1)"
							@blur="onblur(1)" />
					</div>
					<div class="all_tips_red text14 textcolor666 margin_top_10">预留手机号</div>
					<div class="all_tips_input" :class="{ isfocus: phoneFocus }">
						<input class="my_input all_height_line14 text14 textcolor333" v-model="phone" @focus="getFocus(2)"
							@blur="onblur(2)" />
					</div>
					<div class="all_tips_red text14 textcolor666 margin_top_10">手机验证码</div>
					<div class="all_tips_input" :class="{ isfocus: codeFocus }">
						<input class="my_input all_height_line14 text14 textcolor333" v-model="code" @focus="getFocus(3)"
							@blur="onblur(3)" />
						<span class="my_span" v-show="timer == 60" @click="">获取验证码</span>
						<span class="my_span" v-show="timer != 60">{{ timer }}s后再次获取</span>
					</div>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16" @click="jump()">下一步</button>
			</div>
		</div>
		<van-popup v-model:show="showBottom" :overlay="false" position="bottom" >
			<div class="selectStyleList">
				<div class="style">
					<img style="float:left;height: 3rem; margin:.5rem .8rem;" src="../../../assets/images/u360.png">
					<div>
						<div class="all_height_line20 text14 textcolor333 font_weight_900 ">手机认证+人脸识别</div>
						<div class="text12 textcolor999">填写手机号，手机验证码和人脸识别进行个人实名认证</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style">
					<img style="float:left;height: 3rem; margin:.5rem .8rem;" src="../../../assets/images/u360.png">
					<div>
						<div class="all_height_line20 text14 textcolor333 font_weight_900 ">银行卡认证+人脸识别</div>
						<div class="text12 textcolor999">填写银行卡号与银行卡预留手机号和人脸识别进行个人实名认证</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showBottom = false">取&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				timer: 60,
				backnuFocus: false,
				phoneFocus: false,
				codeFocus: false,
				authStyle: '1', //0手机认证+人脸识别 1银行卡认证+人脸识别
				backNumber: '',
				phone: '',
				code: '',
				showBottom: false,
			}
		},
		methods: {
			jump() {
				this.$router.push({
					path: 'personalauthcomplete'
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.selectstyle {
		display: inline-block;
		white-space: nowrap;
		width: 4rem;
	}

	.selectstyle::after {
		content: url('../../../assets/images/u359.png');
		//content: '退';
		width: 1.4rem;
		height: 1.4rem;
		line-height: 1.4rem;
		margin: 0 .5rem;
	}

	.selectStyleList {
		position: relative;

		.style {
			height: 4rem;
			padding-right:.5rem;
		}
	}
</style>